<script setup>
import { NTabs, NTabPane, NButton, NDrawer, NDrawerContent } from 'naive-ui'
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { calculateProgress } from '@/public'
</script>

<template>
    <div class="center">
        <el-scrollbar class="main-scrollbar" id="drawer-target">
            <div :style="{ width: '880px', display: 'flex', marginBottom: '100px' }">
                <div class="divbg"
                    :style="{ width: '880px', height: '300px', position: 'absolute', backgroundColor: currentProject?.color ?? defaultColor, marginTop: '49px' }">
                </div>
                <div class="div1"></div>

                <el-image class="no-select" style="width: 300px;height: 300px;flex:none;margin-top: 49px;"
                    src="image/QQ图片20240713125331.png"></el-image>
                <div class="div1"></div>
                <span style="margin-top: 64px;color: white;z-index:1;font-size: 40px;"
                    v-if="projects.length === 0">完全胜利!!!</span>
                <n-tabs v-if="projects.length > 0" v-model:value="tabSelect" type="card" @update:value="tabChange">
                    <template #prefix>
                        <div style="width:0px"></div>
                    </template>
                    <n-tab-pane v-for="p in projects" :key="p.id" :name="p.id"
                        :style="{ backgroundColor: 'transparent', height: '284px', padding: '8px' }">
                        <template #tab>
                            <div :class="tabSelect === p.id ? 'mytab-active' : 'mytab'"
                                :style="{ backgroundColor: p.color }">
                                <span
                                    :class="tabSelect === p.id ? 'mytab-text-active no-select' : 'mytab-text no-select'">{{
                                        p.extraData.totalProgress ?? '\u200B'
                                    }}</span>
                            </div>
                        </template>
                        <div v-if="calculateProgress(p) !== '100%'" style="display:flex;flex-direction:column">
                            <span v-for="c in getContents(p)" :key="c">{{ c }}</span>
                        </div>
                        <div v-else style="display:flex;flex-direction:column">
                            <span>done</span>
                        </div>
                    </n-tab-pane>
                </n-tabs>
                <div class="div2" style="display: flex;" v-if="currentProject !== null">
                    <n-button round color="#ffffff"
                        :style="{ alignSelf: 'flex-end', marginBottom: '16px', color: currentProject?.color ?? defaultColor, fontSize: '22px' }"
                        @click="urge()">辣手催花</n-button>
                </div>
                <n-drawer v-model:show="showdrawer" :width="200" :height="300" placement="bottom" :trap-focus="false"
                    :block-scroll="false" :show-mask="false" to="#drawer-target">
                    <n-drawer-content
                        :style="{ backgroundColor: currentProject?.color ?? defaultColor, color: 'white' }">
                        <n-button text size="large" @click="showdrawer = false"
                            style="width:100px;position: absolute; top: 10px;left: 50%;transform: translateX(-50%)">
                            <template #icon>
                                <svg :style="{ fill: 'white', transform: 'scale(1.5)' }"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                                </svg>
                            </template>
                        </n-button>
                        <el-scrollbar style="height: 248px;margin-top:20px">
                            <span style="white-space: pre-wrap;">{{ bulletin }}</span>
                        </el-scrollbar>
                    </n-drawer-content>
                </n-drawer>
            </div>
            <n-button text size="large" @click="showdrawer = true"
                style="width:100px;position: absolute; bottom: 10px;left: 50%;transform: translateX(-50%)">
                <template #icon>
                    <svg :style="{ fill: currentProject?.color ?? defaultColor, transform: 'scale(1.5)' }"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z" />
                    </svg>
                </template>
            </n-button>
        </el-scrollbar>
    </div>
</template>

<script>
export default {
    name: "DDL",
    data() {
        return {
            apiUrl: 'https://api.hotarukawa.live',
            projects: [],
            tabSelect: 0,
            currentProject: null,
            bulletin: '',
            showdrawer: false,
            defaultColor: '#f3d19e',
        }
    },
    methods: {
        ddlLoadData() {
            let _this = this
            axios({
                method: 'get', url: this.apiUrl + '/api/project/public?idHash=6e997076453b59fa7f2dc30041a8882f4e849f143a33512b734ea8a321ad100f'
            }).then(function (response) {
                _this.projects = response.data.items.filter(p => p.type?.progressType === 0)
                if (response.data.items.length > 0) {
                    _this.tabSelect = response.data.items[0].id
                    _this.currentProject = response.data.items[0]
                }
                else {
                    _this.tabSelect = null
                    _this.currentProject = null
                }
                _this.bulletin = response.data.bulletin
            })
        },
        tabChange(id) {
            this.currentProject = this.projects.filter(x => x.id === id)[0]
        },
        urge() {
            //let _this = this
            axios({
                method: 'post', url: this.apiUrl + '/api/reminder', data: { projectId: this.currentProject.id }
            }).then(function () {
                ElMessage({
                    message: '成功揪下来了一片向日葵花瓣，总觉得主播又变秃了一点……',
                    type: 'success',
                })
            }).catch(function (error) {
                if (error.status === 403)
                    ElMessage.error('大失败! 发量稀疏的向日葵给了你一拳，然后带着服务器去钓鱼了!')
            })
        },
        getContents(p) {
            const now = new Date()
            const startTime = new Date(p.startTime)
            const endTime = new Date(p.endTime)
            const lastProgress = p.progresses.length ? p.progresses.at(-1) : null
            let contents = []
            if (startTime > now) {
                contents.push('似乎还没有开始动工的样子......')
                contents.push(`距离开工还有${GetDiffDays(startTime, now)}天`)
                contents.push(`还有${this.projects.indexOf(p)}个稿件就可以动工辣！`)
            }
            else if (startTime <= now && endTime > now) {
                contents.push(`已耗时${GetDiffDays(now, startTime)}日，当前进度${lastProgress?.currentProgress ?? 0}${p.extraData.totalProgress ? ('/' + p.extraData.totalProgress) : ''}`)
                if (lastProgress === null && now.Date - startTime.Date >= 3 ||
                    lastProgress !== null && now.Date - new Date(lastProgress.creationTime + 'Z').Date >= 3) {
                    contents.push('总感觉好像卡住了的样子？！')
                    contents.push('去问问是什么情况吧！')
                }
                else {
                    const now0 = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                    let lastCount = 0
                    let todayLast = 0
                    for (let i = 0; i < p.progresses.length; i++) {
                        if (new Date(p.progresses[i].creationTime + 'Z') < now0)
                            lastCount = Number(p.progresses[i].progress)
                        else
                            todayLast = Number(p.progresses[i].progress)
                    }
                    const todayCount = todayLast - lastCount
                    if (todayCount <= 0)
                        contents.push(`诶？还没上工？`)
                    else if (todayCount <= 4)
                        contents.push(`在摸鱼！快催催稿！`)
                    else if (todayCount <= 8)
                        contents.push(`感觉还能再加把劲的样子！`)
                    else
                        contents.push(`非常努力了！快夸夸孩子！`)
                }
            }
            else if (endTime <= now)
            {
                return []
            }

            contents.push(`距离DDL还有${GetDiffDays(endTime, now)}天`)
            if (lastProgress?.nextReportProgress)
                contents.push(`距离下一次进度反馈还有${(Number(lastProgress.nextReportProgress) - Number(lastProgress.currentProgress))}句`)
            contents.push(`当前余稿：${this.projects.length}`)
            contents.push(`上次更新：${lastProgress ? new Date(lastProgress.creationTime + 'Z').toLocaleString() : "无"}`)

            return contents

            function GetDiffDays(d1, d2) {
                return Math.floor((d1 - d2) / (1000 * 60 * 60 * 24))
            }
        }
    },
    mounted() {
        this.ddlLoadData()
    }
}
</script>

<style>
.center {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Zhifeiji;
    font-size: 22px;
}

.main-scrollbar>.el-scrollbar__wrap {
    display: flex;
    align-items: center;
}

.mytab {
    height: 100%;
    font-size: 22px;
    width: 4px;
    padding: 8px;
    color: white;
    border-radius: 4px 4px 0 0;
    transition: width 1s cubic-bezier(0.16, 1, 0.3, 1);
}

.mytab:hover {
    width: fit-content;
    transition: width 1s cubic-bezier(0.16, 1, 0.3, 1);
}

.mytab-active {
    height: 100%;
    font-size: 22px;
    padding: 8px 16px;
    color: white;
    border-radius: 4px 4px 0 0;
    transition: width 1s cubic-bezier(0.16, 1, 0.3, 1);
    width: fit-content;
}


.n-tabs .n-tabs-tab-wrapper {
    transition: width 1s cubic-bezier(0.16, 1, 0.3, 1);

}

.n-tabs .n-tabs-pane-wrapper {
    overflow: visible;
}

.n-tabs .n-tabs-tab-wrapper:hover {
    width: fit-content;
    transition: width 1s cubic-bezier(0.16, 1, 0.3, 1);
}


.mytab-text {
    opacity: 0;
    transition: opacity 1s cubic-bezier(0.16, 1, 0.3, 1);
}

.mytab-text-active {
    opacity: 1;
    transition: opacity 1s cubic-bezier(0.16, 1, 0.3, 1);
}

.mytab:hover .mytab-text {
    opacity: 1;
    transition: opacity 1s cubic-bezier(0.16, 1, 0.3, 1);
}

.n-tabs .n-tabs-tab {
    padding: 0;
}

.n-tabs .n-tab-pane {
    padding: 8px !important;
    color: white;
}

.n-tabs .n-tabs-nav.n-tabs-nav--top.n-tabs-nav--card-type .n-tabs-tab {
    border: 0 !important;
}

.n-tabs .n-tabs-nav.n-tabs-nav--top.n-tabs-nav--card-type .n-tabs-tab-pad {
    border: 0 !important;
}

.n-tabs .n-tabs-nav.n-tabs-nav--top.n-tabs-nav--card-type .n-tabs-pad {
    border: 0 !important;
}

.n-tabs .n-tabs-nav.n-tabs-nav--card-type .n-tabs-nav__prefix,
.n-tabs .n-tabs-nav.n-tabs-nav--card-type .n-tabs-nav__suffix {
    border: 0 !important;
}

.n-tabs .n-tabs-pane-wrapper {
    border-radius: 4px;
}

:root {
    interpolate-size: allow-keywords;
}

.n-tabs.n-tabs--top .n-tab-pane {
    animation: background-color 1s cubic-bezier(0.16, 1, 0.3, 1);
    opacity: 0;
    animation: fadeIn 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        /* 动画开始时透明度为 0 */
    }

    to {
        opacity: 1;
        /* 动画结束时透明度为 1 */
    }
}

.divbg {
    transition: background-color 1s cubic-bezier(0.16, 1, 0.3, 1);
}

.div1 {
    width: 32px;
    height: 300px;
    margin-top: 49px;
    flex: none;
}

.div2 {
    margin-left: 16px;
    width: 140px;
    height: 300px;
    margin-top: 49px;
    flex: none;
}

.no-select {
    user-select: none;
}
</style>